module.exports = __webpack_public_path__ + "img/2.5d_3.895f635c.jpg";